import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface ProductAlertResponse {
  id: number;
  storeId: number;
  productId: number;
  productName?: string;
  sku?: string;
  alertQuantity: number;
  currentQuantity?: number;
  active?: boolean;
  lastAlertedAt?: string;
}

export interface ProductAlertRequest {
  storeId: number;
  productId: number;
  alertQuantity: number;
  active?: boolean;
}

export const productAlertsApi = {
  list: (storeId: number) =>
    unwrap(api.get<ApiResponse<ProductAlertResponse[]>>('/v1/product-alerts', { params: { storeId } })),
  save: (body: ProductAlertRequest) =>
    unwrap(api.post<ApiResponse<ProductAlertResponse>>('/v1/product-alerts', body)),
  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/product-alerts/${id}`)),
};
